import styled from "styled-components";
import { BREAKPOINT_MAX } from "../../../styles/responsiveBreakpoints";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.tokens.color.surface.primary};
  padding: ${({ theme }) => `${theme.tokens.padding.lg}px ${theme.tokens.padding.xl}px`};
  border-radius: 4px;
  gap: ${({ theme }) => `${theme.tokens.spacing.content.lg}px`};

  @media (max-width: ${BREAKPOINT_MAX.md}px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    padding: ${({ theme }) => `${theme.tokens.padding.md}px ${theme.tokens.padding.lg}px`};

    & > * {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 44px;
  background-color: ${({ theme }) => theme.tokens.color.border.primary};
  flex-shrink: 0;

  @media (max-width: ${BREAKPOINT_MAX.md}px) {
    width: 100%;
    height: 1px;
    margin: 0.25rem 0;
  }
`;
